import { core } from '@/core'
import Basic from '@basic'

import TableHeader from './table-header'

const util = {
  template: {
    table(opt, tar) {
      return $(`
      <div class="lt-table">
        <div class="hidden-columns" id="hiddenColumns"></div>
        <div class="table__header-wrapper" id="headerWrapper"></div>
        <div class="table__body-wrapper" id="bodyWrapper">
          <div class="table__empty-block" id="emptyBlock">
            <span class="table__empty-text" id="emptyBlockText">未查出任何数据</span>
          </div>
          <div class="table__append-wrapper" id="appendWrapper"></div>
        </div>
        <div class="table__footer-wrapper" id="footerWrapper"></div>
        <div class="table__fixed" id="fixedWrapper">
          <div class="table__fixed-header-wrapper" id="fixedHeaderWrapper"></div>
          <div class="table__fixed-body-wrapper" id="fixedBodyWrapper">
            <div class="table__append-gutter" id="fixedBodyGutter"></div>
          </div>
          <div class="table__fixed-footer-wrapper" id="fixedFooterWrapper"></div>
        </div>
        <div class="table__fixed-right" id="rightFixedWrapper">
          <div class="table__fixed-header-wrapper" id="rightFixedHeaderWrapper"></div>
          <div class="table__fixed-body-wrapper" id="rightFixedBodyWrapper">
            <div class="table__append-gutter" id="rightFixedBodyGutter"></div>
          </div>
          <div class="table__fixed-footer-wrapper" id="rightFixedFooterWrapper"></div>
        </div>
        <div class="table__fixed-right-patch" id="rightFixedPatch"></div>
        <div class="table__column-resize-proxy" id="resizeProxy"></div>
      </div>`)
    },
  },
  pullTableHeader(opt, tar) {
    const { headerWrapper } = tar.members
    const ht = new TableHeader()
    headerWrapper.append(ht.unit)
    return ht
  },
  updater: {
    fit(value, opt, tar, node) {},
    stripe(value, opt, tar, node) {},
    border(value, opt, tar, node) {},
    isGroup(value, opt, tar, node) {},
    isHidden(value, opt, tar, node) {},
    maxHeight(value, opt, tar, node) {},
    showHeader(value, opt, tar, node) {},
  },
}

export default class Table extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      fit: false, // 禁用
      stripe: false, // 禁用
      border: false, // 禁用
      isGroup: false, // 禁用
      isHidden: false, // 禁用
      maxHeight: false, // 禁用
      showHeader: false, // 禁用
    }
    this.events = {
      reset: null,
    }
    this.settings = Object.assign({}, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.table(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.headerTable = util.pullTableHeader(opt, this)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {}

  currentChange() {}

  trimFinal() {}

  set data(value) {
    this.settings.data = value
  }

  get data() {
    return this.settings.data
  }
}
